module.exports = __webpack_public_path__ + "img/cloud-drizzle-lightning.73dd657d.svg";